import { ReactNode, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { redirectToLogin } from '@/shared/util';
import { useAuthStore } from '@/store';

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const [requestedLocation, setRequestedLocation] = useState<null | string>(null);

  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const { pathname } = useLocation();

  // Note: isAuthenticated stays true until error interceptor's timeout fires,
  // so this won't trigger during the delayed redirect scenario
  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }

    redirectToLogin();

    return null;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);

    return <Navigate to={requestedLocation} />;
  }

  return children;
}
